module.exports = __webpack_public_path__ + "static/media/cash-for-junk-car-brisbane.e799faa5.png";